import type { RtCond } from './types';

export function rtCondToURLSearchParams(rtCond: RtCond) {
  const params = new URLSearchParams();

  for (const [key, values] of Object.entries(rtCond)) {
    values.forEach((value) => {
      params.append(key, value);
    });
  }

  return params;
}

export function setJrdpSearchParams(isJRDP: boolean, jrdpQuery?: string) {
  const jrdpSearchParams = new URLSearchParams();
  if (isJRDP && jrdpQuery) {
    jrdpSearchParams.set('f_jrdp', '1');
    jrdpSearchParams.set('f_jrdpquery', jrdpQuery);
  }

  return jrdpSearchParams;
}

export function appendJrdpSearchParams(path: string, isJRDP: boolean = false, jrdpQuery?: string) {
  const url = new URL(path);
  const jrdpSearchParams = setJrdpSearchParams(isJRDP, jrdpQuery);

  url.search = jrdpSearchParams.toString();

  return url.toString();
}
